export const translateStatus = (status: string): string => {
  const statusMap: Record<string, string> = {
    'UNPROCESSED': 'Необработанный',
    'AT_WORK': 'В работе',
    'COMPLETED': 'Завершен',
    'NON_CALL': 'Недозвон',
    'INVALID': 'Невалидный лид',
    'POSTPONED': 'Отложенный',
    'BONUS': 'Бонусный'
  };
  
  return statusMap[status] || status;
};

export const getStatusColor = (status: string): string => {
  const colorMap: Record<string, string> = {
    'UNPROCESSED': '#6c757d',
    'AT_WORK': '#ffc107',
    'COMPLETED': '#28a745',
    'NON_CALL': '#6f42c1',
    'INVALID': '#dc3545',
    'POSTPONED': '#6c757d',
    'BONUS': '#fd7e14'
  };
  
  return colorMap[status] || '#2196f3';
}; 